import { useConsentsState, setConsentsState } from "@account/consents-shared-lib";
import { instana } from "@crystal/analytics";
import { useMfProps, isBrowser, useIsomorphicData } from "@crystal/core";
import { createGlassHttp } from "@crystal/glass-bridge";
import { useState, useEffect } from "react";
import { consentsConfig } from "../config/config.js";
import { getScenario, mapConsentPayload, hasInvalidConsents, patchPermission } from "../lib/index.js";
import { DOC_TYPES } from "../types/index.js";
const PAID_MEDIA_INTENT_COOKIE = "paidMediaIntent";
const mapIntentConsents = (data, type) => {
  const explicitDocuments = data.explicitDocuments.map((doc) => {
    return type === doc.document.documentType ? {
      ...doc,
      configuration: {
        ...doc.configuration,
        acceptancePreSelected: true,
        accepted: true,
        hidden: true
      }
    } : doc;
  });
  return {
    ...data,
    explicitDocuments
  };
};
const useScenario = (scenarioType) => {
  const config = consentsConfig.evaluateWithContext(useMfProps().context);
  const locale = config.locale.replace("_", "-");
  const isInBrowser = isBrowser();
  const updateState = (data2) => {
    setScenario(data2);
    setConsentsState({
      [scenarioType]: {
        payload: mapConsentPayload(data2, locale),
        isValid: !hasInvalidConsents(data2)
      }
    });
  };
  const { data, refetch, info } = useIsomorphicData(
    {
      id: `consents_${scenarioType}`,
      info: {
        config,
        scenarioType
      }
    },
    async ({ config: config2, scenarioType: scenarioType2 }) => {
      try {
        const data2 = await getScenario(config2)(scenarioType2);
        if (isInBrowser && document.cookie.includes(PAID_MEDIA_INTENT_COOKIE)) {
          return mapIntentConsents(data2, DOC_TYPES.PAID_MEDIA);
        }
        return data2;
      } catch (_e) {
        instana("reportError", _e, {
          meta: {
            errorId: "PMS_Failed",
            locale,
            scenarioType: scenarioType2
          }
        });
      }
    }
  );
  const [scenario, setScenario] = useState(
    data || { scenarioName: "", implicitDocuments: [], explicitDocuments: [] }
  );
  useEffect(() => {
    if (data) {
      updateState(data);
    }
  }, [data]);
  useEffect(() => {
    if (isInBrowser) {
      refetch(info);
    }
  }, [isInBrowser]);
  const onChange = async (doc) => {
    const updatedDocuments = scenario.explicitDocuments.map((d) => {
      if (d.document.documentType === doc.document.documentType) {
        d.configuration.accepted = doc.configuration.accepted;
      }
      return d;
    });
    updateState({
      ...scenario,
      explicitDocuments: updatedDocuments
    });
  };
  return {
    scenario,
    onChange
  };
};
const usePermissions = (shouldFetch) => {
  const [permissions, setPermissions] = useState([]);
  const consentsState = useConsentsState();
  const { sitePath } = consentsConfig.evaluateWithContext(useMfProps().context);
  useEffect(() => {
    const fetch = async () => {
      try {
        const api = createGlassHttp();
        const response = await api.get(`/api/permissions/get-permissions`, {
          query: {
            ...sitePath ? { sitePath } : {}
          }
        });
        setPermissions(response);
      } catch (e) {
        setPermissions([]);
      }
    };
    shouldFetch && fetch();
  }, []);
  const onChange = async (doc) => setPermissions(await patchPermission(doc, consentsState));
  return {
    permissions,
    onChange
  };
};
export {
  usePermissions,
  useScenario
};
//# sourceMappingURL=api-client.js.map
